(() => {
  const KEY = 'cdg-consent-v1';
  const root = document.querySelector('[data-cdg-consent]');
  if (!root) return;

  const prefs = root.querySelector('[data-cdg-consent-prefs]');
  const analyticsInput = root.querySelector('[data-cdg-consent-analytics]');
  const marketingInput = root.querySelector('[data-cdg-consent-marketing]');
  const saveBtn = root.querySelector('[data-cdg-consent-save]');
  const ga4 = root.dataset.ga4?.trim();
  const meta = root.dataset.meta?.trim();

  function readConsent() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function storeConsent(value) {
    localStorage.setItem(KEY, JSON.stringify(value));
  }

  function setShopifyConsent(value) {
    const payload = {
      analytics: Boolean(value.analytics),
      marketing: Boolean(value.marketing),
      preferences: Boolean(value.analytics),
      sale_of_data: false
    };
    const apply = () => window.Shopify?.customerPrivacy?.setTrackingConsent?.(payload, () => {});
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      apply();
      return;
    }
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) apply();
    });
  }

  function loadGa4() {
    return new Promise((resolve) => {
      if (!ga4 || document.getElementById('cdg-ga4')) {
        resolve();
        return;
      }
      const src = document.createElement('script');
      src.id = 'cdg-ga4';
      src.async = true;
      src.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(ga4)}`;
      src.onload = resolve;
      src.onerror = resolve;
      document.head.append(src);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
      window.gtag('config', ga4);
    });
  }

  function loadMeta() {
    if (!meta || document.getElementById('cdg-meta-pixel')) return;
    const src = document.createElement('script');
    src.id = 'cdg-meta-pixel';
    src.text = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('consent','grant');fbq('init','${meta.replace(/'/g, '')}');fbq('track','PageView');`;
    document.head.append(src);
  }

  async function applyTags(value) {
    setShopifyConsent(value);
    if (value.analytics) await loadGa4();
    if (value.marketing) loadMeta();
    if (!window.__cdgTrackingReady) {
      window.__cdgTrackingReady = true;
      document.dispatchEvent(new Event('cdg:tracking-ready'));
    }
  }

  function hideBanner() {
    root.hidden = true;
  }

  function showBanner() {
    root.hidden = false;
  }

  function choose(analytics, marketing) {
    const value = { analytics, marketing, at: Date.now() };
    storeConsent(value);
    applyTags(value);
    hideBanner();
  }

  const saved = readConsent();
  if (saved) {
    hideBanner();
    applyTags(saved);
  } else {
    showBanner();
    setShopifyConsent({ analytics: false, marketing: false });
  }

  root.querySelector('[data-cdg-consent-all]')?.addEventListener('click', () => choose(true, true));
  root.querySelector('[data-cdg-consent-needed]')?.addEventListener('click', () => choose(false, false));
  root.querySelector('[data-cdg-consent-toggle]')?.addEventListener('click', () => {
    const open = prefs.hidden;
    prefs.hidden = !open;
    saveBtn.hidden = !open;
    if (analyticsInput) analyticsInput.checked = Boolean(saved?.analytics);
    if (marketingInput) marketingInput.checked = Boolean(saved?.marketing);
  });
  saveBtn?.addEventListener('click', () => {
    choose(Boolean(analyticsInput?.checked), Boolean(marketingInput?.checked));
  });

  document.querySelector('[data-cdg-consent-open]')?.addEventListener('click', (event) => {
    event.preventDefault();
    showBanner();
    prefs.hidden = false;
    saveBtn.hidden = false;
  });
})();
